import React, { useState, useEffect } from 'react';
// Přidáno: možnost opětovného vyvolání banneru přes event
import './CookieConsent.css';

/**
 * GDPR Cookie Consent Banner
 * 
 * Komponenta pro správu souhlasu uživatele s cookies a inicializaci GA4.
 * - Zobrazí se při první návštěvě
 * - Výběr je uložen do localStorage
 * - Po souhlasu inicializuje Google Analytics
 */
export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Listener pro otevření banneru z patičky
    const openHandler = () => setIsVisible(true);
    window.addEventListener('openCookieSettings', openHandler);
    return () => window.removeEventListener('openCookieSettings', openHandler);
  }, []);

  useEffect(() => {
    // Zkontroluj, zda již uživatel neudělil/neodmítl souhlas
    const consent = localStorage.getItem('cookie_consent');
    if (consent === null) {
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    try {
      // Ulož souhlas do localStorage
      localStorage.setItem('cookie_consent', 'true');
      
      // Skryj banner
      setIsVisible(false);

      // Inicializace GA4 bude provedena v App.jsx po detekci změny localStorage
      // Zde dispatchneme custom event pro informování App komponenty
      window.dispatchEvent(new CustomEvent('cookieConsentChanged', { 
        detail: { consent: 'accepted' } 
      }));

      console.log('[CookieConsent] Souhlas s cookies přijat');
    } catch (error) {
      console.error('[CookieConsent] Chyba při ukládání souhlasu:', error);
    }
  };

  const handleReject = () => {
    try {
      // Ulož odmítnutí do localStorage
      localStorage.setItem('cookie_consent', 'false');
      
      // Skryj banner
      setIsVisible(false);

      console.log('[CookieConsent] Souhlas s cookies odmítnut');
    } catch (error) {
      console.error('[CookieConsent] Chyba při ukládání odmítnutí:', error);
    }
  };

  // Pokud není viditelný, nevrátí nic
  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-content">
          <div className="cookie-consent-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 8v4M12 16h.01" />
            </svg>
          </div>
          <div className="cookie-consent-text">
            <h3 className="cookie-consent-title">Souhlas se soubory cookies</h3>
            <p className="cookie-consent-description">
              Tato webová stránka používá cookies pro zajištění funkčnosti a analytické účely. Vaše údaje neprodáváme ani nepoužíváme pro cílenou reklamu. Více informací v naší{' '}
              <a href="/cookies" target="_blank" rel="noopener noreferrer">Cookie Policy</a>.
            </p>
          </div>
        </div>
        <div className="cookie-consent-actions">
          <button
            onClick={handleReject}
            className="cookie-consent-btn cookie-consent-btn-secondary"
            type="button"
          >
            Jen nezbytné
          </button>
          <button
            onClick={handleAccept}
            className="cookie-consent-btn cookie-consent-btn-primary"
            type="button"
          >
            Souhlasím se vším
          </button>
        </div>
      </div>
    </div>
  );
}
